<kendo-expansionpanel
    class="margin-bottom-30"
    title="{{ 'grid.columns.actions' | translate }}"
    style="width: 100%"
    [disabled]="!(companyTasks && companyTasks.length > 0) || isDocumentCanceled">
    <kendo-gridlayout [gap]="{ rows: 5 }" style="width: 100%">
        <kendo-gridlayout-item *ngFor="let task of companyTasks; index as i" [row]="i + 1">
            <div kendoPopoverContainer [popover]="actionPopover" showOn="hover" [filter]="'.has-popover-' + task.taskId">
                <button
                    style="width: 100%"
                    kendoButton
                    [look]="'outline'"
                    type="button"
                    themeColor="info"
                    [ngClass]="task.description && task.description !== '' ? 'has-popover-' + task.taskId : ''"
                    (click)="initiateAction(task)">
                    {{ task.title }}
                </button>
                <kendo-popover #actionPopover [body]="task.description" [width]="300"></kendo-popover>
            </div>
        </kendo-gridlayout-item>
    </kendo-gridlayout>
</kendo-expansionpanel>
